import type { Hook } from '../types';

export function formatDataNumberValue(
  value: number,
  params: {
    type: string;
    unit?: string;
  }
) {
  return {
    value,
    unit: ''
  } as ReturnType<Hook['formatDataNumberValue']>;
}

export default formatDataNumberValue;
